export const aboutDiagramUrl = '/decoded-assets/aboutDiagram.png';
export const aimieLogoUrl = '/decoded-assets/aimieLogo.webp';
export const aimieLogoBrightUrl = '/decoded-assets/aimieLogoBright.webp';
export const complexReflectionsLectureWallpaperUrl = '/decoded-assets/complexReflectionsLectureWallpaper.webp';
export const complexReflectionsLectureWallpaperLightUrl = '/decoded-assets/complexReflectionsLectureWallpaperLight.webp';
export const fullSessionLectureWallpaperUrl = '/decoded-assets/fullSessionLectureWallpaper.webp';
export const fullSessionLectureWallpaperLightUrl = '/decoded-assets/fullSessionLectureWallpaperLight.webp';
export const simpleReflectionLectureWallpaperUrl = '/decoded-assets/simpleReflectionLectureWallpaper.webp';
export const simpleReflectionLectureWallpaperLightUrl = '/decoded-assets/simpleReflectionLectureWallpaperLight.webp';
export const specificSkillsLectureWallpaperUrl = '/decoded-assets/specificSkillsLectureWallpaper.webp';
export const specificSkillsLectureWallpaperLightUrl = '/decoded-assets/specificSkillsLectureWallpaperLight.webp';
export const uoftLogoUrl = '/decoded-assets/uoftLogo.png';
export const camhLogoUrl = '/decoded-assets/camhLogo.png';

export const getAimieLogoUrl = (theme = 'dark') =>
  theme === 'light' ? aimieLogoBrightUrl : aimieLogoUrl;

export const getComplexReflectionsLectureWallpaperUrl = (theme = 'dark') =>
  theme === 'light'
    ? complexReflectionsLectureWallpaperLightUrl
    : complexReflectionsLectureWallpaperUrl;

export const getFullSessionLectureWallpaperUrl = (theme = 'dark') =>
  theme === 'light'
    ? fullSessionLectureWallpaperLightUrl
    : fullSessionLectureWallpaperUrl;

export const getSimpleReflectionLectureWallpaperUrl = (theme = 'dark') =>
  theme === 'light'
    ? simpleReflectionLectureWallpaperLightUrl
    : simpleReflectionLectureWallpaperUrl;

export const getSpecificSkillsLectureWallpaperUrl = (theme = 'dark') =>
  theme === 'light'
    ? specificSkillsLectureWallpaperLightUrl
    : specificSkillsLectureWallpaperUrl;
